import type { ClienteApi } from '../cliente';
import { consulta } from '../comun';
import type { components as Web } from '../tipos/web';

export type SitioPublico = Web['schemas']['PublicSite'];
export type WidgetPublico = Web['schemas']['PublicWidget'];
export type EntradaPublica = Web['schemas']['PublicEntry'];

/**
 * Marca del negocio para las páginas públicas del cliente (pedir cita 9.9, reserva pública 8.11; G614, G618): una sola
 * definición que comparten Citas y Reservas.
 */
export function operacionesWebPublicaCliente(api: ClienteApi) {
    return {
        /** getPublicSite (anónima): nombre, marca, idioma, privacidad y la clave pública de la web (`api_key`). */
        getPublicSite: (slug: string, idioma?: string) =>
            api.pedir<SitioPublico>('GET', `/v1/public/sites/${encodeURIComponent(slug)}${consulta({ locale: idioma })}`, { sinSesion: true }),
        /**
         * getPublicEntry (anónima, G885): la entrada del negocio por su slug aunque no tenga web publicada (negocio, marca,
         * privacidad, `site_url` y la clave pública de la web). La usan `/reservar/{slug}`, `/pedir-cita/{slug}` y
         * `/comprar-entradas/{slug}`; cerrada con `status: closed`, sin servirse `410`.
         */
        getPublicEntry: (slug: string, idioma?: string) =>
            api.pedir<EntradaPublica>('GET', `/v1/public/sites/${encodeURIComponent(slug)}/entry${consulta({ locale: idioma })}`, { sinSesion: true }),
        /** getPublicWidget (con la clave del widget): negocio, `theme`, `accent_color` y opciones (`service_id`, `professional_id`, G574). */
        getPublicWidget: (clave: string, idioma?: string) =>
            api.pedir<WidgetPublico>('GET', '/v1/public/widget', { sinSesion: true, cabeceras: { 'X-Api-Key': clave, ...(idioma === undefined ? {} : { 'Accept-Language': idioma }) } }),
    };
}
